import { ValueGetterParams } from 'ag-grid-enterprise';
import { DocumentReader } from 'src/app/modules/core/store/models';

export const userValueGetter = (params: ValueGetterParams) => {
  const field = params.colDef.cellRendererParams.schemaField;

  const reader = new DocumentReader(params.data);

  const nameFieldName = `${field.systemName}_name`;

  const value = reader.getFieldValue(nameFieldName);

  return value;
};
